import React,{Component} from 'react';
import ContentRightPrice from './content-right-price/content-right-price';
import ContentRightHiddenBuy from './content-right-hidden-buy/content-right-hidden-buy';
import ContentRightClients from './content-right-clients/content-right-clients';
import ContentRightCustomeReport from './content-right-custome-report/content-right-custome-report';

class ContentRight extends  Component {

    constructor(props) {
        super(props);
        this.state = this.props.data_data;
        console.log('data from main',this.state)
    }


    render() {
        return (
            <div class="report_side rightsc">
                <ContentRightPrice data_price={this.state} />

                <div class="" id="rside_fixed">

                    {/*<ContentRightHiddenBuy />*/}

                    <ContentRightHiddenBuy  data={this.state}/>


                    <div>
                        <ContentRightClients />

                        <div>

                            <ContentRightCustomeReport custome={this.state} />

                        </div>

                    </div>

                </div>



            </div>
        )
    }
}

export default ContentRight


// WEBPACK FOOTER //
// ./src/report-description/content/content-right/content-right.js